import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import masterAgentService from '../../services/master-agent-request';
import TableMasterAgent from 'components/TableMasterAgent';
import { useCompany, useUser } from 'models';

function MyOrders() {
  const user = useUser()
  const { company } = useCompany();
  const [filters, setFilters] = useState(!company ? {} : { company: company.document })
  const [data, setData] = useState([])
  const [columns, setColumns] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [filtersList, setFiltersList] = useState({    
    'Razão Social Cliente': {
      width: 2,
      type: 'input',
      comparator: 'like'
    },
    'Periodo': {
      width: 2,
      ref: 'Data de Fechamento do Pedido',
      type: 'date',
      comparator: 'between',
      data: {
        from: { label: 'Periodo Inicial', value: null },
        to: { label: 'Periodo Final', value: null }
      }
    }
  }); 

  useEffect(() => {
    const get = async () => {
      setIsLoading(true)
      const response = await masterAgentService.getAllOrders(filters)
      const {collection, columns} = response.data
      setColumns(columns)
      setData(collection)
      setIsLoading(false)
    }
    get();
  }, []);

  return (
    <Row>
      <Col md="12" className="mt-3">        
        <TableMasterAgent
          setFiltersList={setFiltersList}
          showActionsButton
          isLoading={isLoading}
          collection={data}
          columns={columns}
          filtersList={filtersList}
          btnAddProps={{
            url: '/master-agent/new-order',
            label: 'Novo Pedido '
          }}
          fileExportName={'MA-Meus Pedidos'}
        />          
      </Col>
    </Row>
  );
}

export default MyOrders;
